import EDC from '../../../shared/globals';
import { AnswerMark } from '../../../shared/mark-animation';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';
import router from '@/router';

EDC.Games.BullseyeMatchText.Scenes.Main = function () {
  const gameId = router.currentRoute.params.id;
  BaseMinigamesMain.apply(this);

  this.gameConfig = store.getters['games/getGameById'](gameId).sets[0].config;
  this.gameData = EDC.Games.BullseyeMatchText.GameData;
  this.difficulty = 1;
  this.iteration = 0;
  this.target = null;
  this.questionText = null;
  this.choices = [];
};

EDC.Games.BullseyeMatchText.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
// eslint-disable-next-line max-len
EDC.Games.BullseyeMatchText.Scenes.Main.prototype.constructor = EDC.Games.BullseyeMatchText.Scenes.Main;

const BMT = EDC.Games.BullseyeMatchText.Scenes.Main.prototype;

BMT.create = function () {
  this.initialize();

  this.createTemplateUI();
  this.loadIteration();

  this.createBasicUI();
};

BMT.createTemplateUI = function () {
  this.target = this.add.sprite(1200, 390, 'target');
  let title; let instructions;
  const { titleImg } = this.gameConfig;
  const { instructionsImg } = this.gameConfig;
  if (titleImg) {
    title = this.add.sprite(330, 190, 'title').setOrigin(0.5);
  } else {
    title = this.make.text({
      x: 30,
      y: 30,
      text: this.gameConfig.titleTxt,
      origin: { x: 0, y: 0 },
      style: {
        fontFamily: `${this.gameConfig.font}`,
        fontSize: `${this.gameConfig.titleSize}`,
        wordWrap: { width: '850' },
        lineSpacing: 5,
        align: 'center',
      },
    });
  }
  if (instructionsImg) {
    instructions = this.add.sprite(310, 620, 'instructions').setOrigin(0.5);
  } else {
    instructions = this.make.text({
      x: 30,
      y: 450,
      text: this.gameConfig.instructionsTxt,
      origin: { x: 0, y: 0 },
      style: {
        fontFamily: `${this.gameConfig.font}`,
        fontSize: `${this.gameConfig.instructionsSize}`,
        wordWrap: { width: '700' },
        lineSpacing: 5,
        align: 'center',
      },
    });
  }
};

BMT.loadIteration = function () {
  this.createQuestion();
  this.addchoices();
};

BMT.createQuestion = function () {
  const target = this.target;
  const font = {
    font: '280px Arial',
    fill: 'white',
    stroke: '#f00',
    strokeThickness: 7,
  };
  const { question } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const questionText = this.add.text(target.x, target.y, question, font);
  questionText.y = target.y - questionText.displayHeight / 2;
  questionText.x = target.x - questionText.displayWidth / 2;
  this.questionText = questionText;
};

BMT.addchoices = function () {
  const font = {
    font: '80px Arial',
    fill: 'white',
    stroke: '#f00',
    strokeThickness: 7,
  };
  const { choices } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const { correctAnswer } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  for (let i = 0; i < choices.length; i++) {
    let dart;
    const container = this.add.container(0, 0);
    if (i > 1) {
      dart = this.add.sprite(0, 30, 'dart-right');
      container.isRight = true;
    } else {
      dart = this.add.sprite(0, 30, 'dart-left');
    }
    // eslint-disable-next-line max-len
    const choiceText = this.add.text(-dart.displayWidth / 2, -dart.displayHeight + 30, choices[i], font);
    container.add(dart);
    container.add(choiceText);
    container.x = 760 + 320 * i;
    container.y = 870;
    container.init_x = container.x;
    container.init_y = container.y;
    container.setSize(dart.displayWidth, dart.displayHeight + choiceText.displayHeight);
    if (i === correctAnswer - 1) {
      container.isCorrect = true;
    } else {
      container.isCorrect = false;
    }
    container.setInteractive();
    container.markAnim = new AnswerMark(this, container).setScale(0.45);
    container.setData('markAnim', container.markAnim);
    this.cursorManager.setDefaultDraggableEvents(container);
    this.input.setDraggable(container);
    container.on(
      'drag',
      ((sprite, pointer, x, y) => {
        sprite.setPosition(x, y);
      }).bind(this, container),
    );
    container.on('dragend', this.onDragStop.bind(this, container), this);
    this.choices.push(container);
  }
};

BMT.onDragStop = function (dragObj) {
  if (dragObj.x > 800 && dragObj.y < 710) {
    if (dragObj.isCorrect) {
      this.playCorrect();
      this.choices.map((x) => {
        x.disableInteractive();
        return true;
      });
      this.dartAnimation(dragObj);
      this.time.delayedCall(2700, this.nextIteration, [], this);
    } else {
      dragObj.first.setTint(0xffa500);
      dragObj.next.setStroke().setTint(0xffa500);
      dragObj.disableInteractive();
      this.playWrong();
      dragObj.x = dragObj.init_x;
      dragObj.y = dragObj.init_y;
      dragObj.getData('markAnim').showMark(false, () => {});
    }
  } else {
    dragObj.x = dragObj.init_x;
    dragObj.y = dragObj.init_y;
  }
};

BMT.dartAnimation = function (dragObj) {
  const target = this.target;
  if (dragObj.isRight) {
    dragObj.x = target.x + 400;
    dragObj.y = target.y + 150;
    this.tweens.add({
      targets: dragObj,
      x: target.x + 100,
      y: target.y,
      duration: 600,
      ease: 'Sine.easeInOut',
      delay: 100,
    });
  } else {
    dragObj.x = target.x - 400;
    dragObj.y = target.y + 150;
    this.tweens.add({
      targets: dragObj,
      x: target.x - 100,
      y: target.y,
      duration: 600,
      ease: 'Sine.easeInOut',
      delay: 100,
    });
  }
};

BMT.nextIteration = function () {
  this.iteration = this.iteration + 1;
  if (!this.gameConfig.sets[this.difficulty].iterations[this.iteration]) {
    this.showSummary();
  } else {
    this.questionText.destroy();
    this.questionText = null;
    this.choices.map((x) => {
      x.destroy();
      return true;
    });
    this.choices = [];
    this.loadIteration();
  }
};

export default EDC.Games.BullseyeMatchText.Scenes.Main;
